import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Todo.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function LoginPrompt({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token);
    } catch { setError('密码错误'); }
  };
  return (
    <div className="todo-login">
      <form onSubmit={submit}>
        <h2>TODO</h2>
        <input type="password" placeholder="密码" value={password}
          onChange={e => setPassword(e.target.value)} autoFocus />
        {error && <p className="todo-login-error">{error}</p>}
        <button type="submit">进入</button>
      </form>
    </div>
  );
}

// /todo runs in immersive mode (navbar is a floating overlay), so the
// sticky-wall iframe fills the full viewport. Notes persist server-side
// (see /api/todo-wall), so any device sees the same board.
export default function Todo() {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  if (!token) return <LoginPrompt onLogin={setToken} />;
  return (
    <iframe
      className="todo-wall-frame"
      src="/sticky-wall.html"
      title="便签墙"
    />
  );
}
